import { useFragment } from 'react-relay';
import type {
  SurgeryTimelineFragment$key,
  SurgeryTimelineFragment$data,
} from '../graphql/__generated__/SurgeryTimelineFragment.graphql';
import { surgeryTimeLineFragment } from '../graphql';

export function useSurgeryTimeLineData(hospitalData: SurgeryTimelineFragment$key): SurgeryTimelineFragment$data {
  return useFragment(surgeryTimeLineFragment, hospitalData);
}
